import { render, staticRenderFns } from "./ref-view.vue?vue&type=template&id=782b6984&scoped=true"
import script from "./ref-view.vue?vue&type=script&lang=js"
export * from "./ref-view.vue?vue&type=script&lang=js"
import style0 from "./ref-view.vue?vue&type=style&index=0&id=782b6984&prod&lang=css"
import style1 from "./ref-view.vue?vue&type=style&index=1&id=782b6984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b6984",
  null
  
)

export default component.exports